// Implements: F-UIX-017
/**
 * Whether a key event comes from somewhere the person is typing.
 *
 * Page-wide shortcuts (cancel a turn, change version) MUST stay out of fields: a key pressed
 * in a field belongs to the field. Only the fields' own shortcuts (Ctrl/Cmd+Enter to send)
 * live inside them, and those are bound on the field itself, not here.
 */

const TYPING = [
  "input",
  "textarea",
  "select",
  '[contenteditable]:not([contenteditable="false"])',
  '[role="textbox"]',
  '[role="combobox"]',
].join(", ");

export function isEditableTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(TYPING) !== null;
}
